import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import React from "react";

import usePublishDialog from "./PublishDialog.hook";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const PublishDialog = ({ open, onClose, handleSubmit, skipConfirmStep = false }) => {
  const { dialogContent } = usePublishDialog({
    onClose,
    handleSubmit,
    skipConfirmStep
  });

  return (
    <Dialog data-testid="publish-dialog" maxWidth="sm" fullWidth open={open}>
      <DialogTitle>{dialogContent.title}</DialogTitle>
      <DialogContent>
        <Typography
          data-testid={"publish-dialog-subtitle"}
          style={{ whiteSpace: "pre-line" }}
          variant="body1"
          color="text.800"
        >
          {dialogContent.subtitle}
        </Typography>
        {dialogContent.step === 1 && (
          <TextField
            data-testid={"publish-dialog-text-field"}
            fullWidth
            sx={{ mt: 3 }}
            label={dialogContent.label}
            value={dialogContent.changeDescription}
            onChange={({ target: { value } }) =>
              dialogContent.setChangeDescription(value)
            }
            onKeyDown={dialogContent.handleKeyPress}
          />
        )}
        {dialogContent.error && (
          <Typography
            variant="inputLabel"
            color="error.500"
          >
            {dialogContent.error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <HyroButton variant={BUTTON_VARIANTS.TEXT} color={BUTTON_COLORS.SECONDARY} data-testid={"publish-dialog-close-button"} onClick={dialogContent.handleCancel}>Back to editing</HyroButton>
        <HyroButton
          data-testid={"publish-dialog-publish-button"}
          variant={BUTTON_VARIANTS.CONTAINED}
          onClick={dialogContent.handlePublish}
          disabled={dialogContent.disablePublish}
        >
          {dialogContent.actionButtonText}
        </HyroButton>
      </DialogActions>
    </Dialog >
  );
};

export default PublishDialog;
